export const errors = [53103]

export const findError = (error) => errors.find((err) => Number(error) === err)
